import React from 'react';

import AnswerImage from './answer-image';
import AnswerVideo from './answer-video';
import { TARMiniGame } from '../../types/game-document/entities/task-content';

export const AnswerAR: React.FC<{
  type: TARMiniGame;
  contentCenter?: boolean;
  answerInput: Record<string, any>;
}> = ({ type, contentCenter = true, answerInput }) => {
  const formatDuration = (seconds: number): string => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs.toString().padStart(2, '0')}`;
  };

  const renderAnswer = () => {
    switch (type) {
      case 'Game Cube':
        return (
          <div className={'d-flex flex-column'}>
            {answerInput.passed ? (
              <span className={'text-success'}>Passed</span>
            ) : (
              <span className={'text-danger'}>Fail</span>
            )}
            <span>Duration: {formatDuration(answerInput.duration)}</span>
          </div>
        );
      case 'Meerkats Moves':
        return (
          <AnswerVideo
            selectedImage={answerInput.videoUrl}
            isDisabled
            formId=""
            taskId=""
            isUploading={false}
            isOnline
          />
        );
      case 'Sound Waves':
        return <span>Answer rate: {answerInput.correctAnswerRate / 20}/5</span>;
      case 'Summer Suitcase':
        return (
          <div className={'d-flex flex-column'}>
            {answerInput.passed ? (
              <span className={'text-success'}>Passed</span>
            ) : (
              <span className={'text-danger'}>Fail</span>
            )}
            <span>Duration: {formatDuration(answerInput.duration)}</span>
          </div>
        );
      case 'The Portal':
        return (
          <div className={'d-flex flex-column align-items-center'}>
            {answerInput.passed ? (
              <span className={'text-success'}>Passed</span>
            ) : (
              <span className={'text-danger'}>Fail</span>
            )}
            <AnswerImage
              selectedImage={answerInput.photoUrl}
              isDisabled
              formId=""
              taskId=""
              isUploading={false}
              isOnline
            />
          </div>
        );
      case 'Where in the World?':
      case 'Where in the World? - Easy':
      case 'Where in the World? - Hard':
        return (
          <div className={'d-flex flex-column'}>
            <span>Answer rate: {answerInput.correctAnwerRate / 20}/5</span>
            <span>Duration: {formatDuration(answerInput.duration)}</span>
          </div>
        );
    }
  };

  return (
    <div
      className={`d-flex ${contentCenter && 'justify-content-center'} h-100 overflow-y-auto overflow-x-hidden`}>
      <div className={`d-flex flex-column`}>
        <div
          id={`answer-type-${type}`}
          className={`answer-container d-flex align-items-center h-100 w-100`}>
          {renderAnswer()}
        </div>
      </div>
    </div>
  );
};
